import {decorate, inject, injectable} from '@yosmanyga/di'
import {AbstractTranslatorResourceLoader} from './AbstractTranslatorResourceLoader'
import {ResourceLoader} from "./ResourceLoader";
import {LanguageManager} from './LanguageManager'

class Translator {
    resource!: object

    constructor(
        private abstractTranslatorResourceLoader: ResourceLoader,
        private languageManager: LanguageManager
    ) {
    }

    load = async (
        path: string
    ) => {
        this.resource = await this.abstractTranslatorResourceLoader.load(path) as object
    }

    t = (
        key: string
    ) => {
        if (typeof this.resource === 'undefined') {
            throw new Error(`Translator resource not loaded`)
        }

        if (typeof this.resource[key as keyof typeof this.resource] === 'undefined') {
            throw new Error(`No translation found for "${key}"`)
        }

        return this.resource[key as keyof typeof this.resource][this.languageManager.get() as string]
    }
}

decorate(injectable(), Translator)
decorate(inject(AbstractTranslatorResourceLoader), Translator, 0)
decorate(inject(LanguageManager), Translator, 1)

export {
    Translator
}
